import React from 'react';
import CubeIcon from '@svg/cube';
import styled from 'styled-components';

import { Button, Modal } from '@common/index';
import { alpha, Chip, Stack } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { flowActions } from '@store/slices';
import { AppDispatch, State, tabActions } from '@store/index';
import { useTheme } from '../../../styles/theme';
import { ModuleWorkflowsAssigned } from '@components/Workspace/routes/Workflows';
import { useNavigate, useParams } from 'react-router-dom';
import { DeviceHubOutlined } from '@mui/icons-material';

const WorkflowHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0.25rem;
  padding: 0.5rem;

  p {
    font-size: 13px;
    color: ${({ theme }) => theme.text.subtext};
  }
`;

const WorkflowRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid ${({ theme }) => theme.line.light};
  padding: 0.5rem;
  border-radius: 6px;

  svg {
    color: ${({ theme }) => theme.primary};
  }

  &:last-of-type {
    border-bottom: 0;
  }

  &:hover {
    background-color: ${({ theme }) => alpha(theme.background.inverse, 0.06)};
    cursor: pointer;
  }
`;

export const ViewModuleWorkflows: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const theme = useTheme();

  const { service_id } = useParams();

  const attachedWorkflows = useSelector((state: State) => state.flow.viewModuleWorkflows);
  const open = attachedWorkflows !== null;
  const setOpen = (val: ModuleWorkflowsAssigned[] | null) => dispatch(flowActions.setViewModuleWorkflows(val));

  const openWorkflow = (workflowId: string) => {
    dispatch(tabActions.setIdentifier(workflowId));
    setOpen(null);
    navigate(`/${service_id}/workflow/${workflowId}`);
  };

  return (
    <Modal
      open={open}
      setOpen={setOpen as (val: boolean | string | null) => void}
      header='Used in Workflows'
      background={theme.primary}
      icon={<CubeIcon height={22} />}
      info='All workflows that are currently using this module. Click the workflow to open it on the canvas.'
      body={
        <Stack>
          <WorkflowHeader>
            <p>Workflow Name</p>
            <p>Workflow Node Count</p>
          </WorkflowHeader>
          {attachedWorkflows?.map((attachedWorkflow) => (
            <WorkflowRow key={attachedWorkflow.flow_id} onClick={() => openWorkflow(attachedWorkflow.flow_id)}>
              <Stack spacing={1.25} direction='row' alignItems='center'>
                <DeviceHubOutlined fontSize='small' />
                <p>{attachedWorkflow.name}</p>
              </Stack>
              <Stack spacing={2} direction='row' alignItems='center'>
                <Chip sx={{ width: '80px' }} label={`${attachedWorkflow.node_count} Nodes`} size='small' />
              </Stack>
            </WorkflowRow>
          ))}
        </Stack>
      }
      actions={
        <Stack direction='row' spacing={1}>
          <Button small onClick={() => setOpen(null)}>
            Close
          </Button>
        </Stack>
      }
    />
  );
};
